import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Front/Header";
import Footer from "./Front/Footer";
import API_BASE_URL from "../Config";
import { toast } from "react-toastify";
import "./styles/OrderSuccess.css";
import "../styles/global.css";

const OrderSuccess = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [orderId, setOrderId] = useState(null);
  const [countdown, setCountdown] = useState(8);

  useEffect(() => {
    try {
      const hash = window.location.hash;
      const queryString = hash.includes("?") ? hash.split("?")[1] : "";
      const params = new URLSearchParams(queryString);
      const id = params.get("order_id");
      console.log("Order ID:", id);
      if (!id) { setStatus("failed"); return; }
      setOrderId(id);
      fetch(`${API_BASE_URL}api/verify-order/${id}`)
        .then(res => res.json())
        .then(data => {
          console.log("Verify Response:", data);
          if (data.order_status === "PAID") { setStatus("success"); }
          else { setStatus("failed"); }
        })
        .catch(() => { setStatus("failed"); });
    } catch (err) { console.error(err); setStatus("failed"); }
  }, []);

  // Auto-redirect countdown on success
  useEffect(() => {
    if (status !== "success") return;
    if (countdown <= 0) { navigate("/myprofile"); return; }
    const timer = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [status, countdown, navigate]);

  return (
    <>
      <Header />

      <div className="os-page">
        <div className="container">
          <div className="os-bread">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                <li className="breadcrumb-item active">Order Status</li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="os-center">
          <div className="os-card">

            {/* ── Loading ── */}
            {status === "loading" && (
              <>
                <div className="os-loading-top">
                  <div className="os-spinner" />
                  <h3 className="os-loading-title">Verifying Payment...</h3>
                  <p className="os-loading-sub">Please wait while we confirm your order</p>
                </div>
                <div className="os-card-body">
                  <p className="os-info-text">This usually takes just a few seconds. Please don't close this page.</p>
                </div>
              </>
            )}

            {/* ── Success ── */}
            {status === "success" && (
              <>
                <div className="os-success-top">
                  {/* Confetti pieces */}
                  <div className="os-confetti">
                    {[...Array(20)].map((_, i) => (
                      <div key={i} className="os-confetti-piece" style={{
                        left: `${5 + Math.random() * 90}%`,
                        background: ["#10b981","#1E7A8C","#C38635","#3B82F6","#8B5CF6","#F59E0B","#EC4899"][i % 7],
                        animationDelay: `${Math.random() * 1.5}s`,
                        animationDuration: `${2 + Math.random() * 1.5}s`,
                        width: `${6 + Math.random() * 6}px`,
                        height: `${6 + Math.random() * 6}px`,
                        borderRadius: Math.random() > 0.5 ? "50%" : "2px",
                      }} />
                    ))}
                  </div>
                  <div className="os-check-circle">
                    <svg viewBox="0 0 40 40">
                      <path d="M10 20 L17 27 L30 13" />
                    </svg>
                  </div>
                  <h3 className="os-success-title">Order Confirmed!</h3>
                  <p className="os-success-sub">Your payment was successful</p>
                </div>
                <div className="os-card-body">
                  <div className="os-order-id">
                    <i className="fa-solid fa-receipt" />
                    Order ID: {orderId}
                  </div>
                  <p className="os-info-text">
                    We'll send you a confirmation with booking details shortly. You can track your order from your profile.
                  </p>
                  <div className="os-redirect">
                    Redirecting to profile in
                    <span className="os-redirect-count">{countdown}</span>
                    seconds
                  </div>
                  <Link to="/myprofile" className="os-btn-primary">
                    <i className="fa-solid fa-user" /> Go to My Profile
                  </Link>
                  <Link to="/" className="os-btn-outline">
                    <i className="fa-solid fa-house" /> Back to Home
                  </Link>
                </div>
              </>
            )}

            {/* ── Failed ── */}
            {status === "failed" && (
              <>
                <div className="os-failed-top">
                  <div className="os-x-circle">
                    <svg viewBox="0 0 40 40">
                      <line x1="12" y1="12" x2="28" y2="28" />
                      <line x1="28" y1="12" x2="12" y2="28" />
                    </svg>
                  </div>
                  <h3 className="os-failed-title">Payment Failed</h3>
                  <p className="os-failed-sub">Something went wrong with your payment</p>
                </div>
                <div className="os-card-body">
                  {orderId && (
                    <div className="os-failed-id">
                      <i className="fa-solid fa-receipt" />
                      Order ID: {orderId}
                    </div>
                  )}
                  <p className="os-info-text">
                    Don't worry — no amount has been deducted. Please try again or contact support if the issue persists.
                  </p>
                  <Link to="/cart" className="os-btn-danger">
                    <i className="fa-solid fa-rotate-right" /> Try Again
                  </Link>
                  <Link to="/" className="os-btn-outline">
                    <i className="fa-solid fa-house" /> Back to Home
                  </Link>
                </div>
              </>
            )}

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default OrderSuccess;